const sortingO = [ "","Demand-Low To High", "Demand-High To Low", "Sector"];
export const sorting = () => {
  return sortingO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//**************
const propcomStatusO = ["active", "inactive"];
export const propcomStatus = () => {
  return propcomStatusO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
  }));
};

const propertyForO = ["SALE", "RENT"];
export const propertyFor = () => {
  return propertyForO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
export const propertyForOption = () => {
  return propertyForO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};

//###############
const projectTypeO = [ "","Residential", "Commercial"];
export const projectType = () => {
  return projectTypeO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const categoryO = [ "","MALL", "DDA MKT COMPLEX", "SHOPPING cum OFFICE COMPLEX"];
export const category = () => {
  return categoryO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const areaUnitO = ["", "sq ft", "sq yd", "sq m"];
export const areaUnit = () => {
  return areaUnitO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const propertyTypeO = [
  "",
  "Office Space",
  "Shop",
  "Space in Shopping Mall",
  "Showroom",
  "Commercial Land /Plot",
  "FLAT-DDA",
  "Builder Floor",
];
export const propertyType = () => {
  return propertyTypeO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//** */
const frequencyO = [
  "",
  "One-Time",
  "Monthly",
  "Quaterly",
  "Half-Yearly",
  "Yearly",
  "Other",
];
export const frequency = () => {
  return frequencyO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
const booleanOptionO = [ "","Yes", "No"];
export const booleanOption = () => {
  return booleanOptionO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const numberOptionO = [
  "",
  // "N/A",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "10+",
];
export const numberOption = () => {
  return numberOptionO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const bedroomO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const bedroom = () => {
  return bedroomO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const bathroomO = [
  "",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "10+",
];
export const bathroom = () => {
  return bathroomO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const balconyO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const balcony = () => {
  return balconyO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};


//#######
const furnishedStatusO = [
  "",
  "Newly Furnished",
  "Furnished",
  "Semi-Furnished",
  "Unfurnished",
];
export const furnishedStatus = () => {
  return furnishedStatusO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const wardrobesO = [
  "",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "10+",
];
export const wardrobes = () => {
  return wardrobesO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const acO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const ac = () => {
  return acO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const fanO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const fan = () => {
  return fanO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const bedO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const bed = () => {
  return bedO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const tvO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const tv = () => {
  return tvO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const geyserO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const geyser = () => {
  return geyserO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const bathtubO = ["", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const bathtub = () => {
  return bathtubO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const interiorO = ["", "New", "Old"];
export const interior = () => {
  return interiorO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const chimneyO = ["", "Yes", "No"];
export const chimney = () => {
  return chimneyO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const iglGasConnectionO = ["", "Yes", "No"];
export const iglGasConnection = () => {
  return iglGasConnectionO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const modularKitchenO = ["", "Yes", "No"];
export const modularKitchen = () => {
  return modularKitchenO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};

//#######
const willingToRentOutToO = [
  "",
  "Family",
  "Single Women Only",
  "Single Men Only",
  "Doesn't Matter",
];
export const willingToRentOutTo = () => {
  return willingToRentOutToO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
export const tenantsProfessionO = [
  "",
  "govt job",
  "private job",
  "bussiness men",
  "Doesn't Matter",
];
export const tenantsProfession = () => {
  return tenantsProfessionO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const tenantsWhoAreNonVegetariansO = [ "","Yes", "No", "Doesn't Matter"];
export const tenantsWhoAreNonVegetarians = () => {
  return tenantsWhoAreNonVegetariansO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const tenantsWithPetsO = [ "","Yes", "No", "Doesn't Matter"];
export const tenantsWithPets = () => {
  return tenantsWithPetsO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const companyLeaseO = [ "","Yes", "No", "Doesn't Matter"];
export const companyLease = () => {
  return companyLeaseO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const agreementO = [ "","Registrar", "Notary", "Doesn't Matter"];
export const agreement = () => {
  return agreementO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const occupancyStatusO = [ "","Owner", "Tenant", "Vacant"];
export const occupancyStatus = () => {
  return occupancyStatusO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const loanOfferedByO = ["", "All The Leading Banks"];
export const loanOfferedBy = () => {
  return loanOfferedByO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
// //###############
// const statusO = ['Ready To Move', 'Under Construction'];
// export const status = () => {
//   return statusO.map(value => ({
//     key: value,
//     text: value ? value : " N/A",
//     value: value,style:{fontSize:'18px'}
//   }));
// };

//#######
const typeOfOwnershipO = [ "","Freehold", "Leasehold", "Power of Attorney"];
export const typeOfOwnership = () => {
  return typeOfOwnershipO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const facingO = [
  "",
  "East",
  "West",
  "North",
  "South",
  "North - East",
  "North - West",
  "South - East",
  "South -West",
];
export const facing = () => {
  return facingO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const entryO = [
  "",
  "East",
  "West",
  "North",
  "South",
  "North - East",
  "North - West",
  "South - East",
  "South -West",
];
export const entry = () => {
  return entryO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const OverlookingO = ["", "Park", "Road", "Other Building"];
export const Overlooking = () => {
  return OverlookingO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const carParkingCoveredO = ["", "1", "2", "3", "4", "5", "6", "6+"];
export const carParkingCovered = () => {
  return carParkingCoveredO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############
const carParkingOpenO = ["", "1", "2", "3", "4", "5", "6", "6+"];
export const carParkingOpen = () => {
  return carParkingOpenO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const floorNoO = [
  "",
  "Lower",
  "Middle",
  "Upper",
  "Basement",
  "Ground",
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
  "11th",
  "12th",
  "13th",
  "14th",
  "15th",
  "15+",
  "Top",
];
export const floorNo = () => {
  return floorNoO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const totalFloorsO = [ "","1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "10+"];
export const totalFloors = () => {
  return totalFloorsO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//###############

//###############
const localityO = [
  "Sector-01",
  "Sector-02",
  "Sector-03",
  "Sector-04",
  "Sector-05",
  "Sector-06",
  "Sector-07",
  "Sector-08",
  "Sector-09",
  "Sector-10",
  "Sector-11",
  "Sector-12",
  "Sector-13",
  "Sector-14",
  "Sector-15",
  "Sector-16",
  "Sector-17",
  "Sector-18A",
  "Sector-18B",
  "Sector-19A",
  "Sector-19B",
  "Sector-20",
  "Sector-21",
  "Sector-22",
  "Sector-23",
  "Sector-24",
  "Sector-25",
  "Sector-26",
  "Sector-27",
  "Sector-28",
  "Sector-29",
  "Sector-30",
];
export const locality = () => {
  return localityO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
const cityO = [ "","Dwarka", "Gurugram", "Noida", "Rohini"];
export const city = () => {
  return cityO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};


export const conversionFactorsO = {
  "sq. ft.": {
    "sq. ft.": 1,
    "sq. yards": 0.111111,
    "sq. m.": 0.092903,
    acres: 0.000023,
    hectares: 0.000009,
    bigha: 0.000092,
    marla: 0.003673,
    kanal: 0.000184,
  },
  "sq. yards": {
    "sq. ft.": 9,
    "sq. yards": 1,
    "sq. m.": 0.836127,
    acres: 0.000207,
    hectares: 0.000084,
    bigha: 0.000826,
    marla: 0.033058,
    kanal: 0.001653,
  },
  "sq. m.": {
    "sq. ft.": 10.763915,
    "sq. yards": 1.19599,
    "sq. m.": 1,
    acres: 0.000247,
    hectares: 0.0001,
    bigha: 0.000988,
    marla: 0.039537,
    kanal: 0.001977,
  },
  acres: {
    "sq. ft.": 43560.057264,
    "sq. yards": 4840.006363,
    "sq. m.": 4046.86,
    acres: 1,
    hectares: 0.404686,
    bigha: 4.000005,
    marla: 160.00021,
    kanal: 8.000011,
  },
  hectares: {
    "sq. ft.": 107639.150512,
    "sq. yards": 11959.905612,
    "sq. m.": 10000.0,
    acres: 2.471052,
    hectares: 1,
    bigha: 9.88422,
    marla: 395.368781,
    kanal: 19.768439,
  },
  bigha: {
    "sq. ft.": 10890.0,
    "sq. yards": 1210.0,
    "sq. m.": 1011.71367,
    acres: 0.25,
    hectares: 0.101171,
    bigha: 1,
    marla: 40.0,
    kanal: 2.0,
  },
  marla: {
    "sq. ft.": 272.25,
    "sq. yards": 30.25,
    "sq. m.": 25.292842,
    acres: 0.002529,
    hectares: 0.000009,
    bigha: 0.025,
    marla: 1,
    kanal: 0.05,
  },
  kanal: {
    "sq. ft.": 5445.0,
    "sq. yards": 605.0,
    "sq. m.": 505.856835,
    acres: 0.125,
    hectares: 0.050586,
    bigha: 0.5,
    marla: 20.0,
    kanal: 1,
  },
};
export const conversionFactors = () => {
  return Object.keys(conversionFactorsO).map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};

//#######
const amenitiesDwarkaO = [
  "Power Back Up",
  "InterCom",
  "Lift(s)",
  "Piped Gas",
  "24 Hour Water Supply",
  "Car Parking",
  "Children's Play Area",
  "Community Hall",
  "Club House",
  "Fire Fighting Systems",
  "RO Water System",
  "Waste Disposal",
  "Maintenance Staff",
  "Visitor Parking",
  "Service/Goods Lift",
  "Gated Community",
  "CCTV Camera Security",
  "24x7 Security",
  "Security Cabin",
  // "Electronic Security",
  // "Security / Fire Alarm",
  // "Video Security",
  "Security Personnel",
  // "Escalators",
];
export const amenitiesDwarka = () => {
  return amenitiesDwarkaO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};

//#######
const amenitiesBasicO = [
  "Power Back Up",
  "Piped Gas",
  "24 Hour Water Supply",
  "Car Parking",
  "Children's Play Area",
  "Community Hall",
  "Club House",
  "Centrally AC",
  "Fire Fighting Systems",
  "InterCom",
  "Lift(s)",
  "RO Water System",
  "Water Storage",
  "Visitor Parking",
  "Service/Goods Lift",
  "Escalators",
];
export const amenitiesBasic = () => {
  return amenitiesBasicO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const amenitiesConvSecO = [
  "Maintenance Staff",
  "Internet/wi-fi connectivity",
  "Intercom Facility",
  "Laundry Service",
  "Centrally Air Conditioned",
  "Changing Area",
  "Entrance Lobby",
  "Piped Gas",
  "Water Softener Plant",
  "Wi-Fi Connectivity",
  "Gated Community",
  "CCTV Camera Security",
  "24x7 Security",
  "Security Cabin",
  "Electronic Security",
  "Security / Fire Alarm",
  "Video Security",
  "Security Personnel",
  "Fire Fighting Equipment",
  "Earthquake Resistant",
];
export const amenitiesConvSec = () => {
  return amenitiesConvSecO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const amenitiesEntSocO = [
  "Bar/Chill-Out Lounge",
  "Shopping Malls",
  "Shopping Center",
  "Restaurant",
  "Food Court",
  "Cafeteria",
  "Barbecue",
  "Party Lawn",
  "Reading Lounge",
  "Sun Deck",
  "Theatre",
  "Club House",
  "Multipurpose Hall",
  "Community Hall",
  "Banquet Hall",
  "Waiting Lounge",
  "Conference Room",
];
export const amenitiesEntSoc = () => {
  return amenitiesEntSocO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const amenitiesServO = [
  "Creche/Day care",
  "Grocery Shop",
  "School",
  "Day Care Centre",
  "Bank & ATM",
];
export const amenitiesServ = () => {
  return amenitiesServO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const amenitiesSportFitO = [
  "Badminton Court",
  "Indoor Games",
  "Lawn Tennis Court",
  "Squash Court",
  "Steam Room",
  "Swimming Pool",
  "Table Tennis",
  "Toddler Pool",
  "Yoga/Meditation Area",
  "Aerobic room",
  "Sports Facility",
  "Kids Play Area",
  "Fitness Centre / GYM",
  "Golf Course",
  "Billiards",
  "Jacuzzi",
  "Spa",
  "Indoor Games Room",
  "Indoor/Outdoor Tennis Courts",
  "Jogging and Strolling Track",
  "Cycling  Track",
  "Play Ground",
];
export const amenitiesSportFit = () => {
  return amenitiesSportFitO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const amenitiesEcoO = [
  "Fountain",
  "Garbage Disposal",
  "Landscape Garden/Park",
  "Paved Compound",
  "Sewage Treatment Plant",
  "Terrace Garden",
  "Waste Disposal",
  "green house",
  "solar power",
  "Feng Shui / Vastu Compliant",
  "Rain Water Harvesting",
];
export const amenitiesEco = () => {
  return amenitiesEcoO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
const ageOfConstructionO = [
  "",
  "0+",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "10+",
  "15+",
  "20+",
];
export const ageOfConstruction = () => {
  return ageOfConstructionO.sort().map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};

//#######
const transactionTypeO = [ "","Resale", "New Property", "New Booking"];
export const transactionType = () => {
  return transactionTypeO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};

//#######
const statusO = [
  "",
  "New launch",
  "Under Construction",
  "Ready To Move",
  "Upcoming",
]; //Immediate Possession /possession by date

export const status = () => {
  return statusO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//#######
const possessionO = ["", "Ready To Move", "Ongoing"]; //Immediate Possession

export const possession = () => {
  return possessionO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//############
